/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_No_Audio_WarningInputs */



/**
* | output |
* | --- |
* | "Output will have no audio tracks (video and metadata only)." |
*
* @param {Audio_Embed_Export_No_Audio_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_no_audio_warning = /** @type {((inputs?: Audio_Embed_Export_No_Audio_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_No_Audio_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le résultat ne comportera aucune piste audio (uniquement de la vidéo et des métadonnées).")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Ausgabe enthält keine Audiospur (nur Video und Metadaten).")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'output non conterrà tracce audio (solo video e metadati).")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В выходном файле не будет звуковых дорожек (только видео и метаданные).")
	if (locale === "es") return /** @type {LocalizedString} */ ("La salida no tendrá pistas de audio (solo vídeo y metadatos).")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("输出将不包含音频轨道（仅包含视频和元数据）。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("出力には音声トラックは含まれません（ビデオとメタデータのみ）。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आउटपुट में कोई ऑडियो ट्रैक नहीं होगा (केवल वीडियो और मेटाडेटा)।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O resultado não terá faixas de áudio (apenas vídeo e metadados).")
	return /** @type {LocalizedString} */ ("Output will have no audio tracks (video and metadata only).")
});